export default __webpack_public_path__ + "static/media/audio-content-badge.4a553a94.svg";